module.exports = __webpack_public_path__ + "assets/82b85f5dca6dae373b2f24abe2bca93e.mp3";